import { minutesToMilliseconds } from "date-fns";

import { MeetingNoteVisibility } from "@performyard/models";

import {
	type GetActionItemsSearchParams,
	type GetMeetingWorkspacesParams,
	type GetMeetingsSearchParams,
	type GetUpcomingMeetingsParams,
	getActionItemsSearch,
	getLatestMeetingCarryOverItems,
	getMeetingActionItems,
	getMeetingAgendaItems,
	getMeetingDetails,
	getMeetingNotes,
	getMeetingWorkspaceDetails,
	getMeetingWorkspacesSearch,
	getMeetingsSearch,
	getUpcomingMeetings,
} from "../../../api/services/defs/internal-api";

export const meetingWorkspacesSearchQuery = (params: GetMeetingWorkspacesParams) => ({
	queryKey: ["get-meeting-workspaces-search", params],
	queryFn: () => getMeetingWorkspacesSearch(params),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting workspaces search.",
	},
});

export const meetingWorkspaceDetailsQuery = (workspaceId: string) => ({
	queryKey: ["get-meeting-workspace-by-id", workspaceId],
	queryFn: () => getMeetingWorkspaceDetails(workspaceId),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting workspace details.",
	},
});

export const meetingDetailsQuery = (meetingId: string) => ({
	queryKey: ["get-meeting-details", meetingId],
	queryFn: () => getMeetingDetails(meetingId),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting details.",
	},
});

export const meetingsSearchQuery = (params: GetMeetingsSearchParams) => ({
	queryKey: ["get-meetings-search", params],
	queryFn: () => getMeetingsSearch(params),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting search.",
	},
});

export const latestMeetingCarryOverItemsQuery = (workspaceId: string, startDateTime: Date) => ({
	queryKey: ["get-meeting-carry-over-items-by-workspace", workspaceId, startDateTime],
	queryFn: () => getLatestMeetingCarryOverItems(workspaceId, startDateTime),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting carry over items.",
	},
});

export const meetingAgendaItemsQuery = (meetingId: string) => ({
	queryKey: ["get-meeting-agenda-items-by-meeting", meetingId],
	queryFn: () => getMeetingAgendaItems(meetingId),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting agenda items.",
	},
});

export const meetingActionItemsQuery = (meetingId: string) => ({
	queryKey: ["get-meeting-action-items-by-meeting", meetingId],
	queryFn: () => getMeetingActionItems(meetingId),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting action items.",
	},
});

export const meetingNotesQuery = (meetingId: string, visibility?: MeetingNoteVisibility) => ({
	queryKey: ["get-meeting-notes-by-meeting", meetingId, visibility],
	queryFn: () => getMeetingNotes(meetingId, visibility),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting notes.",
	},
});

export const actionItemsSearchQuery = (params: GetActionItemsSearchParams) => ({
	queryKey: ["get-action-items-search", params],
	queryFn: () => getActionItemsSearch(params),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting action items search.",
	},
});

export const upcomingMeetingsQuery = (params: GetUpcomingMeetingsParams) => ({
	queryKey: ["get-upcoming-meetings", params],
	queryFn: () => getUpcomingMeetings(params),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting upcoming meetings.",
	},
});
